import { API_BASE_URL } from '../../config/api';
import apiCache, { CACHE_TTL } from '../../lib/apiCache';

const infInsKey = (padcodigo, giracodigo) => `infIns:${padcodigo}:${giracodigo}`;

const GiraInfIns = {
  fetch: async (padcodigo, giracodigo) => {
    const key = infInsKey(padcodigo, giracodigo);
    const cached = apiCache.get(key);
    if (cached !== undefined) return cached;

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/infantilinscripcion?padcodigo=${padcodigo}&gira=${giracodigo}`
      );

      const contentType = response.headers.get('content-type');
      const text = await response.text();
      let data = {};
      if (contentType && contentType.includes('application/json') && text) {
        try {
          data = JSON.parse(text);
        } catch {
          return apiCache.set(key, [], CACHE_TTL.INS);
        }
      }

      // 404 or empty result = no registries (valid, not an error)
      if (response.status === 404 || response.ok) {
        const result = data.inscripciones ?? data ?? [];
        return apiCache.set(key, result, CACHE_TTL.INS);
      }

      throw new Error(data.message || data.error || 'Error fetching inscripciones');
    } catch (error) {
      console.error('Error in GiraInfIns.fetch:', error);
      return [];
    }
  },
  countByGira: async (giracodigo) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/cuentaGira?gira=${giracodigo}`
      );
      if (!response.ok) {
        throw new Error('Error fetching count');
      }
      const data = await response.json();
      return data.total;
    } catch (error) {
      console.error('Error in GiraInfIns.countByGira:', error);
      return 0;
    }
  },
  save: async (inscriptionData) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/saveGiraInscripcion`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(inscriptionData)
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error saving inscription: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      apiCache.invalidate('infIns:');
      apiCache.invalidate('giraInfantil');
      return data;
    } catch (error) {
      console.error('Error in GiraInfIns.save:', error);
      throw error;
    }
  },
  getBancoLectura: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/bancoLectura`);
      if (!response.ok) {
        throw new Error('Error fetching BancoLectura');
      }
      const data = await response.json();
      // Handle new response structure: { success: true, bancos: [...], count: ... }
      const bancos = data.bancos || data;
      // Filter where BancoCodigoLectura ends in 0
      return bancos.filter(item => {
        const code = item.BancoCodigoLectura?.toString();
        return code && code.endsWith('0');
      });
    } catch (error) {
      console.error('Error in GiraInfIns.getBancoLectura:', error);
      return [];
    }
  },

  getBonificacion: async (boninscodigo) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/bonificaciones?boninscodigo=${boninscodigo}`);
      if (!response.ok) {
        throw new Error('Error fetching Bonificacion');
      }
      const data = await response.json();
      // Handle new response structure: { success: true, bonificaciones: [...], count: ... }
      return data.bonificaciones || data;
    } catch (error) {
      console.error('Error in GiraInfIns.getBonificacion:', error);
      return [];
    }
  }
};

export default GiraInfIns; 